/**
 * Created by Ning Jiang on 10/12/2018.
 */

import {Currency} from "@nolimitcity/slot-game/bin/core/balance/Currency";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IScreenViewConfig, ScreenView} from "@nolimitcity/slot-game/bin/core/screen/ScreenView";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {UserAgent} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {TimelineLite, TweenLite} from "gsap";
import {CreepyCarnivalBetLineEvent} from "../../betline/CCTwoBetlinesView";
import {CCTNineSliceButton} from "../../component/CCTNineSliceButton";
import {CreepyCarnivalTwoGameConfig} from "../../CreepyCarnivalTwoGameConfig";
import {CreepyCarnivalTwoSoundConfig} from "../../CreepyCarnivalTwoSoundConfig";
import {CreepyCarnivalTwoStrings} from "../../CreepyCarnivalTwoStrings";
import {CreepyCarnivalTwoGameMode} from "../../gamemode/CreepyCarnivalTwoGameMode";
import {CCTwoFreeSpinEntryEvents} from "../freespinintro/CreepyCarnivalTwoFreespinIntroController";
import {CreepyCarnivalTwoParsedGameData} from "../../server/data/CreepyCarnivalTwoParsedGameData";

export class CreepyCarnivalTwoFreespinOutroView extends ScreenView {
    private _container:PIXI.Container;
    private _assetWrapper:PIXI.Container;
    private _curtainBg:PIXI.Sprite;
    // private _timerBG: PIXI.Sprite;
    private _fsExitText:PIXI.Text;
    private _fsWonText:PIXI.Text;
    private _fsWhoaText:PIXI.Text;

    private _youWonStyle:TextStyleOptions = {
        fontSize : "24px",
        fill : "#5F99FF",
        fontWeight : '400',
        fontFamily : "Open Sans"
    };
    private _thatsAllrStyle:TextStyleOptions = {
        fontSize : "20px",
        fill : "#7764FF",
        fontWeight : '400',
        fontFamily : 'Open Sans',
    };
    private _youWonNoStyle:TextStyleOptions = {
        fontSize : "30px",
        fill : "#7764FF",
        fontWeight : '400',
        fontFamily : 'Open Sans',
    };
    private _totalWin:any;
    private _fsWonNumber:PIXI.Text;


    constructor(config:IScreenViewConfig, autoClose:boolean = false) {
        super(config, autoClose);
    }

    protected createGameGraphics():PIXI.DisplayObject {
        this._container = new PIXI.Container();
        this._assetWrapper = new PIXI.Container();

        this._curtainBg = new PIXI.Sprite(GameResources.getTextures("curtain_fs")[0]);

        let mask = new PIXI.Graphics();
        mask.beginFill(0xFFFFFF, 1);
        mask.drawRect(-385, -260, 800, 700);
        mask.endFill();
        // this._timerBG = new PIXI.Sprite(GameResources.getTextures("assets/timerBG")[0]);
        // this._timerBG.anchor.set(0.5);
        // this._timerBG.scale.set(1, 0.8);
        // this._timerBG.position.set(0, 266);
        // this._timerBG.alpha = 0;

        this._container.addChild(mask);
        this._assetWrapper.mask = mask;

        this._curtainBg.anchor.set(0.5);
        this._curtainBg.position.set(-10, 0);
        this._curtainBg.scale.set(1.001, 1);

        this._fsExitText = new PIXI.Text(` ${Translation.translate(CreepyCarnivalTwoStrings.FS_OUTRO_EXIT_TEXT)} `, this._thatsAllrStyle);
        this._fsExitText.anchor.set(0.5);
        this._fsExitText.position.set(-10, -50);
        this._fsExitText.skew.set(0, 0.05);

        this._fsWonNumber = new PIXI.Text('', this._youWonNoStyle);
        this._fsWonNumber.anchor.set(0.5);
        this._fsWonNumber.position.set(-10, 48);
        this._fsWonNumber.skew.set(0, 0.05);

        this._fsWonText = new PIXI.Text(` ${Translation.translate(CreepyCarnivalTwoStrings.FS_OUTRO_WON_TEXT)} `, this._youWonStyle);
        this._fsWonText.anchor.set(0.5);
        this._fsWonText.position.set(-10, 0);
        this._fsWonText.skew.set(0, -0.03);


        this._fsWhoaText = new PIXI.Text(` ${Translation.translate(CreepyCarnivalTwoStrings.FS_OUTRO_WHOA_TEXT)} `, this._youWonStyle);
        this._fsWhoaText.anchor.set(0.5);
        this._fsWhoaText.position.set(-10, 98);
        this._fsWhoaText.skew.set(0, -0.03);

        this._assetWrapper.addChild(this._curtainBg);
        // this._assetWrapper.addChild(this._timerBG);
        this._assetWrapper.addChild(this._fsExitText);
        this._assetWrapper.addChild(this._fsWonText);
        this._assetWrapper.addChild(this._fsWonNumber);
        this._assetWrapper.addChild(this._fsWhoaText);

        this._container.addChild(this._assetWrapper);

        return this._container;
    }

    protected createButton():CCTNineSliceButton {
        const text:string = Translation.translate(this._config.buttonText ? this._config.buttonText : "CONTINUE");
        const textStyle:TextStyleOptions = this.getScaledButtonTextStyle();
        const button = new CCTNineSliceButton(() => this.onButtonClick(), ` ${text} `, textStyle, this._config.buttonBackgroundConfig);
        button.enabled = false;
        button.visible = false;
        return button;
    }

    protected onResizeGameGraphics(resizeData:IResizeData):void {
        this._container.position.set(this._screenWidth * 0.5, this._screenHeight * 0.5);

        // this._timerBG.width = this._autoCloseTimer.width + 50;
        if(resizeData.orientation === Orientation.PORTRAIT) {
            this._container.x = (this._container.x + 10);
            this._container.y = (this._container.y + 3);
        } else if(UserAgent.isMobile) {
            this._container.x = (this._container.x + 10);
            this._container.y = (this._container.y - 10);
        } else {
            this._container.x = (this._container.x + 10);
            this._container.y = (this._container.y - 10);
        }
    }

    protected startPresentation(data?:ParsedServerData, onShowComplete?:() => void):void {
        this._button.visible = false;
        // this._autoCloseTimer.visible = false;
        this._totalWin = data!.totalWin;
        let symbol = Currency.getPlayerCurrency().symbol;
        const _currencySymbol = symbol ? symbol : "";
        if(Currency.getPlayerCurrency().before) {
            this._fsWonNumber.text = " " + _currencySymbol + " " + MathHelper.roundToDecimals(this._totalWin, 2).toFixed(2);
        } else {
            this._fsWonNumber.text = " " + MathHelper.roundToDecimals(this._totalWin, 2).toFixed(2) + " " + _currencySymbol;
        }

        const timeline:TimelineLite = new TimelineLite(),
            animationDuration:number = 1,
            // #312
            totalWinBelowStake: boolean = (SlotGame.api.gameClientConfiguration.belowStakeWinRestriction && (this._totalWin <= (data! as CreepyCarnivalTwoParsedGameData).playedBetValue));

        this._assetWrapper.alpha = 1;

        timeline.add([
            TweenLite.fromTo(this._assetWrapper, animationDuration, {y : -800}, {y : -25}),

            // switch to main game ambiance sound
            () => SlotGame.sound.fadeAmbience(1, 200),
            () => SlotGame.sound.playAmbience(CreepyCarnivalTwoSoundConfig.instance.MAIN_GAME_AMBIANCE),
            () => {
                // #312
                if (!totalWinBelowStake) {
                    SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.FS_OUTRO);
                }
            }
        ], 0);

        timeline.add(() => {
            EventHandler.dispatchEvent(new GameEvent(CCTwoFreeSpinEntryEvents.PLAY_SMOKE_ANIMATION, false));
        }, timeline.totalDuration());
        timeline.add(() => {
            this._button.visible = true;
            // this._autoCloseTimer.visible = true;
        }, timeline.totalDuration());

        timeline.add(() => {

            if(onShowComplete) {
                onShowComplete();
                // this._timerBG.alpha = 1;
            }
        });
        timeline.play(0);
    }

    protected stopPresentation(closeCallback?:() => void):void {
        const timeline:TimelineLite = new TimelineLite({paused : true});
        EventHandler.dispatchEvent(new GameEvent(CCTwoFreeSpinEntryEvents.KILL_FREE_GAME_BULBS));
        timeline.add(() => {
            TweenLite.fromTo(this._assetWrapper, 1, {y : -25}, {y : -800});
            this._button.visible = false;
            // this._autoCloseTimer.visible = false;
            // this._timerBG.alpha = 0;

            let allBetlines = CreepyCarnivalTwoGameConfig.instance.BETLINES;
            let additionalFreeSpinBetLines = allBetlines.filter(function(v, i) {
                // check the index is odd
                return i % 2 == 0;
            });
            EventHandler.dispatchEvent(new GameEvent(CreepyCarnivalBetLineEvent.HIDE_FREE_SPIN_ALL_BET_LINES, additionalFreeSpinBetLines));
        });
        timeline.add(() => {
            super.stopPresentation(closeCallback);
            EventHandler.dispatchEvent(new GameEvent(GameModeEvent.CHANGE_MODE, {newMode : CreepyCarnivalTwoGameMode.NORMAL}));
        }, timeline.totalDuration() + 0.5);
        timeline.play(0);
    }
}